import { useState } from 'react'

/** Input text that follows `value` whenever the URL moves it, but keeps partial typing. */
export function useDraft(value: string): [string, (next: string) => void] {
  const [draft, setDraft] = useState(value)
  const [source, setSource] = useState(value)
  if (source !== value) {
    setSource(value)
    setDraft(value)
  }
  return [draft, setDraft]
}
